export default {
  de: {
    close: 'Schließen',
    downloadOptions: 'Download-Optionen',
    iiifManifest: 'IIIF-Manifest',
    image: 'Einzelbild',
    limitedDownloadOptions: 'Begrenzte Download-Optionen',
    otherDownloadOptions: 'Andere Download-Optionen',
    pixels: 'Pixel',
    showDownloadOptions: 'Download-Optionen anzeigen',
    suppressedDownloads: 'Download nicht erlaubt',
  },
  en: {
    close: 'Close',
    downloadOptions: 'Download options',
    iiifManifest: 'IIIF manifest',
    image: 'Single image',
    limitedDownloadOptions: 'Limited download options',
    otherDownloadOptions: 'Other download options',
    pixels: 'pixels',
    showDownloadOptions: 'Show download options',
    suppressedDownloads: 'Download not allowed',
  },
  fr: {
    close: 'Fermer',
    downloadOptions: 'Options de téléchargement',
    iiifManifest: 'Manifeste IIIF',
    image: 'Image',
    limitedDownloadOptions: 'Options de téléchargement limitées',
    otherDownloadOptions: 'Autres liens de téléchargement',
    pixels: 'pixels',
    showDownloadOptions: 'Afficher les options de téléchargement',
    suppressedDownloads: 'Téléchargement non autorisé',
  },
};
